import { logOnce } from "../utils";
import { StateStorage } from "./StateStorage";

function tryParseJson<T>(str: string | null): T | undefined {
    try {
        if (str) {
            return JSON.parse(str);
        }
    } catch {
    }
    return undefined;
}

export class BrowserStateStorage<TState> implements StateStorage<TState> {

    private readonly innerStorage: Storage;
    private readonly key: string;

    constructor(
        innerStorage: Storage,
        key: string,
    ) {
        this.innerStorage = innerStorage;
        this.key = key;
    }

    public get(): TState {
        return tryParseJson<TState>(this.innerStorage.getItem(this.key));
    }

    public set(val: TState): void {
        try {
            this.innerStorage.setItem(this.key, JSON.stringify(val));
        } catch {
            logOnce("storage", "Unable to store redux state");
        }
    }

}